import { Heart, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

const waLink = (n) => `https://wa.me/${(n || "").replace(/[^\d]/g, "")}`;

export const Footer = ({ content }) => {
  const contacts = content?.contacts;
  const hasContacts = contacts?.enabled && (contacts.people || []).some((p) => p.whatsapp);

  return (
    <footer className="py-16 text-center px-4" style={{ backgroundColor: "var(--footer-bg)" }} data-testid="footer">
      <Heart className="w-6 h-6 mx-auto text-[var(--gold)]" />
      <h3 className="font-serif italic text-3xl sm:text-4xl text-white mt-4">
        {content?.couple?.partner1} & {content?.couple?.partner2}
      </h3>
      {content?.hashtag && <p className="text-[var(--gold)] text-sm mt-2 tracking-wide" data-testid="footer-hashtag">{content.hashtag}</p>}
      <p className="text-white/60 text-sm mt-3">{content?.hero?.location_label}</p>

      {hasContacts && (
        <div className="mt-7" data-testid="footer-contacts">
          <p className="text-white/85 text-sm">{contacts.title}</p>
          {contacts.note && <p className="text-white/50 text-xs mt-1">{contacts.note}</p>}
          <div className="mt-3 flex flex-wrap justify-center gap-3">
            {(contacts.people || []).filter((p) => p.whatsapp).map((p, i) => (
              <a
                key={i}
                href={waLink(p.whatsapp)}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm text-white border border-white/25 hover:border-[var(--gold)] transition-colors"
                data-testid={`footer-contact-${i}`}
              >
                <MessageCircle className="w-4 h-4 text-green-400" /> {p.name}{p.role ? ` · ${p.role}` : ""}
              </a>
            ))}
          </div>
        </div>
      )}

      <div className="gold-rule w-24 mx-auto my-6" />
      <p className="text-white/50 text-xs tracking-wide">Made with love · We can't wait to celebrate with you</p>
      <Link to="/cms" className="inline-block mt-4 text-white/40 hover:text-white/80 text-xs underline" data-testid="footer-cms-link">
        Admin CMS
      </Link>
    </footer>
  );
};
